import type { I18n } from "@lingui/core";

export interface CallsDateRange {
	from?: Date;
	to?: Date;
}

// Today and the preceding 29 local calendar dates, matching the dashboard.
export function defaultCallsRange(now = new Date()) {
	return recentCallsRange(30, now);
}

export function recentCallsRange(days: number, now = new Date()) {
	const to = new Date(now);
	to.setHours(0, 0, 0, 0);
	const from = new Date(to);
	from.setDate(from.getDate() - (days - 1));
	return { from, to };
}

export function isWithinCallsRange(date: Date, range: CallsDateRange) {
	const from = range.from ? new Date(range.from) : undefined;
	const to = range.to ? new Date(range.to) : undefined;
	from?.setHours(0, 0, 0, 0);
	to?.setHours(23, 59, 59, 999);
	return (!from || date >= from) && (!to || date <= to);
}

export function callPageBounds(
	requestedPage: number,
	pageSize: number,
	total: number,
) {
	const page = Math.max(
		1,
		Math.min(requestedPage, Math.ceil(total / pageSize)),
	);
	const startIndex = (page - 1) * pageSize;
	return { page, startIndex, endIndex: Math.min(startIndex + pageSize, total) };
}

export function formatCallsCount(
	i18n: I18n,
	startIndex: number,
	endIndex: number,
	total: number,
) {
	return total === 0
		? i18n._({ id: "callsCountZero", message: "0 calls" })
		: i18n._({
				id: "callsShowingRange",
				message: "Showing {start}-{end} of {total} calls",
				values: { start: startIndex + 1, end: endIndex, total },
			});
}
